import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const el = document.getElementById('root');
if (!el) {
  document.body.textContent = 'Missing #root element.';
} else {
  ReactDOM.createRoot(el).render(React.createElement(App));
}
